<template>
  <div id="sms-decline-container">
    <MarkdownCopy :content="$t.programDeclineText" />
    <MarkdownCopy :content="$t.generalDeclineText" />
  </div>
</template>

<script setup>
import '@garmin/components-global-web/dist-web/components/GCopy';
import MarkdownCopy from './MarkdownCopy.vue';

defineOptions({
  name: 'SmsDecline',
});
</script>
